(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSArea', SSArea);

    SSArea.$inject = ['$resource', 'DateUtils'];

    function SSArea ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
